<template>
    <Breadcrumbs
        title="Credit Note Report"
        :breadcrumbs="[
            { label: 'Reports', path: '' },
            { label: 'Credit Note Report', path: '/credit-note-report' },
        ]"
    />

    <div class="container-fluid">
        <div class="row project-cards">
            <creditNoteReport />
        </div>
    </div>
</template>

<script>
import creditNoteReport from './credit_note_report_data.vue';

export default {
  name: 'indexList',
  components: {
    creditNoteReport
  },
}
</script>